import React from 'react'
import { cn } from '../../lib/utils'

interface SummaryPriceCardProps {
  label: string
  value: string
  variant?: 'sale' | 'minimum' | 'purchase'
}

const variantLeftBorder: Record<string, string> = {
  sale: 'border-l-emerald-500',
  minimum: 'border-l-amber-500',
  purchase: 'border-l-accent',
}

export const SummaryPriceCard: React.FC<SummaryPriceCardProps> = ({
  label,
  value,
  variant = 'sale',
}) => {
  return (
    <div
      className={cn(
        'bg-card border border-border border-l-[3px] rounded-lg p-3 shadow-precision',
        variantLeftBorder[variant],
      )}
    >
      <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-1.5">
        {label}
      </p>
      <p
        className="text-lg font-semibold text-foreground tabular-nums"
        style={{ fontFamily: '"JetBrains Mono", monospace' }}
      >
        {value}
      </p>
    </div>
  )
}
